// node modules
import React from 'react';

// app modules: components
import Layout from 'components/Layout';
import BlogPost from 'components/BlogPost';

async function action(_, params) {
  const id = Array.isArray(params.id) ? params.id.join('/') : params.id;
  return {
    chunks: ['blog'],
    navigation: {
      heading: 'Features & Stories',
      section: 'Features',
      left: 'back',
    },
    component: (
      <Layout>
        <BlogPost id={id} />
      </Layout>
    ),
  };
}

export default action;
